export function BaiDuMap() {
  return new Promise(function (resolve, reject) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://api.map.baidu.com/api?v=2.0&ak=7VOzdpruO5Pd33UdihdLMze5PTfR4huQ&callback=initMap";
    document.head.appendChild(script);
    //百度会执行下面的函数
    window.initMap = function(){
      resolve(BMap);
      window.onload = Map.load; 
      
      return;
    };
  })
}


// WEBPACK FOOTER //
// ./src/components/BaiDuMap.js